import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { TextInput } from '@tcl-boron-prefabs/text-input';
import styles from './styles.module.css';
import { FormTableField } from './FormTable';
import FormError from './FormError';
import classNames from 'classnames';
import { extractDigits, formatPartialPhoneNumber } from '@tempus/patient-forms-service-shared';

type FormUSPhoneInputProps = FormTableField &
  FieldRenderProps<any> & {
    placeholder?: string;
  };

const ALLOWED_KEYS = [
  'Backspace',
  'Delete',
  'Tab',
  'Escape',
  'Enter',
  'ArrowLeft',
  'ArrowUp',
  'ArrowRight',
  'ArrowDown',
];
const ALLOWED_CTRL_KEYS = ['a', 'c', 'v', 'x'];
const DIGIT_LIMIT = 10;

const FormUSPhoneInput: React.FunctionComponent<FormUSPhoneInputProps> = ({
  input,
  meta,
  placeholder,
  readOnly,
  isError,
}) => {
  const handleChange = (value: string) => {
    const formattedValue = formatPartialPhoneNumber(value);
    input.onChange(formattedValue);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (ALLOWED_KEYS.includes(e.key)) {
      return;
    }

    if ((e.ctrlKey || e.metaKey) && ALLOWED_CTRL_KEYS.includes(e.key.toLowerCase())) {
      return;
    }

    const currentDigits = extractDigits(input.value || '');
    if (currentDigits.length >= DIGIT_LIMIT) {
      e.preventDefault();
    }
  };

  return (
    <div className={classNames(styles.fieldRoot, styles.tableRowContentFocusArea)}>
      <TextInput
        {...input}
        value={input.value ?? ''}
        disabled={meta.submitting || readOnly}
        classes={{
          root: isError ? '' : styles.inputRoot,
          inputWrapper: styles.inputWrapper,
          input: isError ? styles.textInputInputError : styles.inputInput,
        }}
        label={input.name}
        hideLabel
        placeholder={placeholder}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        maxLength={14} // (XXX) XXX-XXXX = 14 characters
      />
      {isError ? <FormError error={meta.error} /> : undefined}
    </div>
  );
};

export default FormUSPhoneInput;
